import { Desktop } from "components";
import { selectOrganizationUnit } from "modules/app/actions";
import { useAppState } from "modules/app/hook";
import { useUserState } from "modules/user/hook";
import { FunctionComponent } from "react";
import { DropdownElement, DropdownWrapper } from "./unit-selection.styles";
import Dropdown, { DropdownItem } from "./dropdown";

const UnitDropdown: FunctionComponent<any> = () => {
  const appState = useAppState();
  const userState = useUserState();
  const { selectedOrganizationData, selectedOrganizationUnitData } = appState;
  const { data: userData } = userState;

  if (!userData || !selectedOrganizationData || !selectedOrganizationUnitData) {
    return null;
  }

  const units =
    userData.systemRole === "sysadmin"
      ? selectedOrganizationData.organizationUnits
      : userData.organizationUnits.filter((unit) => {
          if (unit.organizationUuid === selectedOrganizationData.uuid) {
            return true;
          }
        });

  return (
    <DropdownWrapper>
      <Desktop>
        <div>Organization Unit:</div>
      </Desktop>
      <DropdownElement>
        <Dropdown
          label={selectedOrganizationUnitData.name}
          items={units.map((unit: any) => {
            const item: DropdownItem = {
              text: unit.name,
              onClick: () => {
                selectOrganizationUnit(unit.uuid);
              },
            };
            return item;
          })}
        />
      </DropdownElement>
    </DropdownWrapper>
  );
};

export default UnitDropdown;
